// extracted by mini-css-extract-plugin
export default {"content":"pF-z"};